import config from '../config/config';
import {Contract} from '@ethersproject/contracts';
import {BaseProvider, Web3Provider} from '@ethersproject/providers';
import {parseEther} from '@ethersproject/units';

export function TokenService(provider: BaseProvider) {

    return {
        getERC20TokenContract(tokenAddress: string) {
            const erc20Contract = new Contract(
                tokenAddress,
                config.erc20ABI,
                provider instanceof Web3Provider ? provider?.getSigner() : provider,
            );
            return erc20Contract;
        },
        async geBalance(accountAddress: string | null, tokenAddress: string) {
            let balance = await TokenService(provider).getERC20TokenContract(tokenAddress).balanceOf(accountAddress);
            return balance;
        },

        async allowance(
            accountAddress: string | null,
            amasaStakingAddress: string,
            tokenAddress: string
        ) {
            return TokenService(provider).getERC20TokenContract(tokenAddress).allowance(accountAddress, amasaStakingAddress);
        },
        async approve(amasaStakingAddress: string, tokenAddress: string) {
            return await TokenService(provider).getERC20TokenContract(tokenAddress).approve(
                amasaStakingAddress,
                parseEther('999999999999'),
            );
        },
    };
}
